import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslate } from 'hooks';
import type { HeaderProps } from 'types';

import { SwitchLocale } from '../../switch-locale';

const Header: FC<HeaderProps> = ({ children }) => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  const back = () => {
    navigate('/');
  };

  return (
    <header className="flex items-center justify-between mx-12 py-2 w-full">
      <button
        type="button"
        onClick={back}
        className="flex items-center gap-2.5 text-xl md:left-0 w-6 md:w-[200px]"
      >
        <div className="h-3.5 w-3.5 bg-arrow-left md:h-4 md:w-4" />
        <div className="hidden md:block text-base">{t('1xbet.back')}</div>
      </button>
      <div className="text-lg md:text-xl leading-7 font-medium flex-grow text-center">
        {children}
      </div>
      <div className="w-6 md:hidden" />
      <div className="w-[200px] hidden md:block">
        <SwitchLocale />
      </div>
    </header>
  );
};

export { Header };
